<template>
  <header :class="'site-header ' + variant" vb-background-eps1>
    <b-container>
      <div class="site-header__wrapper">
        <div class="site-header__logo">
          <slot name="logo" />
        </div>
        <div class="site-header__custom-logo" v-if="customization_logo">
          <a :href="customization_logo_url" target="_blank">
            <img :src="customization_logo" alt="" />
          </a>
        </div>
        <div class="site-header__navigation" v-if="show_navigation">
          <slot name="navigation">
            <navigation :direction="'row'" />
          </slot>
        </div>
        <div class="site-header__panel" v-if="show_panel">
          <slot name="panel">
            <panel :variant="variant" />
          </slot>
        </div>
      </div>
    </b-container>
  </header>
</template>

<script>
import Panel from './panel.vue'
import Navigation from "./navigation.vue";
import {get_config} from "@src/utilities";

export default {
  name: "site-header",

  components: {
    'panel': Panel,
    'navigation': Navigation,
  },

  props: {
    variant: {
      type: String,
      default: 'light',
    }
  },

  data() {
    return {};
  },

  computed: {

    customization_logo: () => get_config('guiSettings.customizations.logo', false),
    customization_logo_url: () => get_config('guiSettings.customizations.logoUrl', ''),

    show_navigation() {
      return !this.is_authenticated() && !this.is_mobile()
    },

    show_panel() {
      return this.is_authenticated() || this.is_mobile()
    },
  },

  created() {
  },

  mounted() {
  },

  methods: {
  },
}
</script>

<style lang="scss">

  .site-header {
    user-select: none;
    position: relative;
    z-index: 200;

    &.dark {
      background: $primary;
    }

    &.white {
      background: $white;
    }

    &__wrapper {
      display: flex;
      align-items: center;
      padding: $grid-gutter-width/2 0;
    }

    &__logo {
      flex: 1;

      svg {
        height: 40px;
        width:auto;

        @include media-breakpoint-up(lg) {
          height: 50px;
        }
      }
    }

    &__custom-logo {
      overflow: visible;
      display: flex;
      align-items: center;
      margin-right: $grid-gutter-width / 2;

      img {
        max-height: 48px;
        max-width: 70px;
      }
    }

    &__navigation {
      background-color: $white;
      border-radius: 50px;
      padding: $grid-gutter-width / 3;
    }

    @media print {
      display: none;
    }
  }

</style>